import { render, staticRenderFns } from "./CardsPageClient.vue?vue&type=template&id=ccf50464&"
import script from "./CardsPageClient.vue?vue&type=script&lang=js&"
export * from "./CardsPageClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports